import React, { useState, useEffect } from 'react';
import './ContactInfo.css';

const ContactInfo = ({ 
  phone, 
  email, 
  address, 
  hours, 
  showForm = true, 
  formTitle = 'KONTAKTIEREN SIE UNS',
  settings = {} 
}) => {
  const [language, setLanguage] = useState('de');
  
  // Function to get saved language
  const getSavedLanguage = () => {
    return localStorage.getItem('selectedLanguage') || 'de';
  };
  
  // Initialize language
  useEffect(() => {
    const savedLang = getSavedLanguage();
    setLanguage(savedLang);
  }, []);
  // Поддерживаем как прямые пропсы, так и объект settings
  const finalPhone = phone || settings.phone || '043 818 29 12';
  const finalEmail = email || settings.email || 'info@restaurantdamas.ch';
  const finalAddress = address || settings.address || 'Kyburgstrasse 28\n8037 Zürich';
  const finalHours = hours || settings.hours || 'Montag – Freitag\n11.30 bis 14.00\n17.00 bis 23.30\n\nSamstag & Sonntag\n17.00 bis 23.30';
  const finalShowForm = showForm !== undefined ? showForm : (settings.showForm !== undefined ? settings.showForm : true);
  const finalFormTitle = formTitle || settings.formTitle || 'KONTAKTIEREN SIE UNS';

  // Создаем массив социальных сетей из настроек
  const socialMediaItems = [];
  for (let i = 1; i <= 5; i++) {
    const url = settings[`social${i}Url`];
    const title = settings[`social${i}Title`];
    const type = settings[`social${i}Type`];
    
    if (url && type) {
      socialMediaItems.push({
        url,
        title: title || `Social Media ${i}`,
        type
      });
    }
  }

  // Функция для получения иконки по типу
  const getSocialIcon = (type) => {
    const icons = {
      tripadvisor: tripadvisorIcon,
      yelp: yelpIcon,
      smood: smoodIcon,
      justeat: justeatIcon,
      facebook: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDEyLjA3M2MwLTYuNjI3LTUuMzczLTEyLTEyLTEycy0xMiA1LjM3My0xMiAxMmMwIDUuOTkgNC4zODggMTAuOTU0IDEwLjEyNSAxMS44NTR2LTguMzg1SDcuMDc4di0zLjQ3aDMuMDQ3VjkuNDNjMC0zLjAwNyAxLjc5Mi00LjY2OSA0LjUzMy00LjY2OSAxLjMxMiAwIDIuNjg2LjIzNSAyLjY4Ni4yMzV2Mi45NTNIMTUuODNjLTEuNDkxIDAtMS45NTYuOTI1LTEuOTU2IDEuODc0djIuMjVoMy4zMjhsLS41MzIgMy40N2gtMi43OTZ2OC4zODVDMTkuNjEyIDIzLjAyNyAyNCAxOC4wNjIgMjQgMTIuMDczeiIgZmlsbD0iIzNiNTk5OCIvPgo8L3N2Zz4K",
      instagram: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDIuMTYzYzMuMjA0IDAgMy41ODQuMDEyIDQuODUuMDcgMy4yNTIuMTQ4IDQuNzcxIDEuNjkxIDQuOTE5IDQuOTE5LjA1OCAxLjI2NS4wNjkgMS42NDUuMDY5IDQuODQ5IDAgMy4yMDUtLjAxMiAzLjU4NC0uMDY5IDQuODQ5LS4xNDkgMy4yMjUtMS42NjQgNC43NzEtNC45MTkgNC45MTktMS4yNjYuMDU4LTEuNjQ0LjA3LTQuODUuMDctMy4yMDQgMC0zLjU4NC0uMDEyLTQuODQ5LS4wNy0zLjI2LS4xNDktNC43NzEtMS42OTktNC45MTktNC45Mi0uMDU4LTEuMjY1LS4wNy0xLjY0NC0uMDctNC44NDkgMC0zLjIwNC4wMTMtMy41ODMuMDctNC44NDkuMTQ5LTMuMjI3IDEuNjY0LTQuNzcxIDQuOTE5LTQuOTE5IDEuMjY2LS4wNTcgMS42NDUtLjA2OSA0Ljg0OS0uMDY5em0wLTIuMTYzYy0zLjI1OSAwLTMuNjY3LjAxNC00Ljk0Ny4wNzItNC4zNTguMi02Ljc4IDIuNjE4LTYuOTggNi45OC0uMDU5IDEuMjgxLS4wNzMgMS42ODktLjA3MyA0Ljk0OCAwIDMuMjU5LjAxNCAzLjY2OC4wNzIgNC45NDguMiA0LjM1OCAyLjYxOCA2Ljc4IDYuOTggNi45OCAxLjI4MS4wNTggMS42ODkuMDcyIDQuOTQ4LjA3MiAzLjI1OSAwIDMuNjY4LS4wMTQgNC45NDgtLjA3MiA0LjM1NC0uMiA2Ljc4Mi0yLjYxOCA2Ljk3OS02Ljk4LjA1OS0xLjI4LjA3My0xLjY4OS4wNzMtNC45NDggMC0zLjI1OS0uMDE0LTMuNjY3LS4wNzItNC45NDctLjE5Ni00LjM1NC0yLjYxNy02Ljc4LTYuOTc5LTYuOTgtMS4yODEtLjA1OS0xLjY5LS4wNzMtNC45NDktLjA3M3ptMCA1LjgzOGMtMy40MDMgMC02LjE2MiAyLjc1OS02LjE2MiA2LjE2MnMyLjc1OSA2LjE2MyA2LjE2MiA2LjE2MyA2LjE2Mi0yLjc1OSA2LjE2Mi02LjE2M2MwLTMuNDAzLTIuNzU5LTYuMTYyLTYuMTYyLTYuMTYyem0wIDEwLjE2MmMtMi4yMDkgMC00LTEuNzktNC00IDAtMi4yMDkgMS43OTEtNCA0LTRzNCA1Ljc5MSA0IDRjMCAyLjIxLTEuNzkxIDQtNCA0em02LjQwNi0xMS44NDVjLS43OTYgMC0xLjQ0MS42NDUtMS40NDEgMS40NHMuNjQ1IDEuNDQgMS40NDEgMS40NGMuNzk1IDAgMS40MzktLjY0NSAxLjQzOS0xLjQ0cy0uNjQ0LTEuNDQtMS40MzktMS40MHoiIGZpbGw9IiNlNDQwNWYiLz4KPC9zdmc+",
      twitter: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjk1MyA0LjU3YTEwIDEwIDAgMDEtMi44MjUuNzc1IDQuOTU4IDQuOTU4IDAgMDAyLjE2My0yLjcyM2MtLjk1MS41NTUtMi4wMDUuOTU5LTMuMTI3IDEuMTg0YTQuOTIgNC45MiAwIDAwLTguMzg0IDQuNDgyQzcuNjkgOC4wOTUgNC4wNjcgNi4xMyAxLjY0IDMuMTYyYTQuODIyIDQuODIyIDAgMDAtLjY2NiAyLjQ3NWMwIDEuNzEuODcgMy4yMTMgMi4xODggNC4wOTZhNC45MDQgNC45MDQgMCAwMS0yLjIyOC0uNjE2di4wNmE0LjkyMyA0LjkyMyAwIDAwMy45NDYgNC44MjcgNC45OTYgNC45OTYgMCAwMS0yLjIxMi4wODUgNC45MzYgNC45MzYgMCAwMDQuNjA0IDMuNDE3IDkuODY3IDkuODY3IDAgMDEtNi4xMDIgMi4xMDVjLS4zOSAwLS43NzktLjAyMy0xLjE3LS4wNjdhMTMuOTk1IDEzLjk5NSAwIDAwNy41NTcgMi4yMDljOS4wNTMgMCAxMy45OTgtNy40OTYgMTMuOTk4LTEzLjk4NSAwLS4yMSAwLS40Mi0uMDE1LS42M0E5LjkzNSA5LjkzNSAwIDAwMjQgNC41OXoiIGZpbGw9IiMxZGExZjIiLz4KPC9zdmc+",
      youtube: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjQ5OCA2LjE4NmEzLjAxNiAzLjAxNiAwIDAgMC0yLjEyMi0yLjEzNkMxOS41MDUgMy41NDUgMTIgMy41NDUgMTIgMy41NDVzLTcuNTA1IDAtOS4zNzcuNTA1QTMuMDE3IDMuMDE3IDAgMCAwIC41MDIgNi4xODZDMCA4LjA3IDAgMTIgMCAxMnMwIDMuOTMuNTAyIDUuODE0YTMuMDE2IDMuMDE2IDAgMCAwIDIuMTIyIDIuMTM2YzEuODcxLjUwNSA5LjM3Ni41MDUgOS4zNzYuNTA1czcuNTA1IDAgOS4zNzctLjUwNWEzLjAxNSAzLjAxNSAwIDAgMCAyLjEyMi0yLjEzNkMyNCA1OTMgMjQgMTIgMjQgMTJzMC0zLjkzLS41MDItNS44MTR6TTkuNTQ1IDE1LjU2OFY4LjQzMkwxNS44MTggMTJsLTYuMjczIDMuNTY4eiIgZmlsbD0iI2ZmMDAwMCIvPgo8L3N2Zz4K"
    };
    return icons[type] || icons.facebook;
  };

  // Функция для получения цвета по типу
  const getSocialColor = (type) => {
    const colors = {
      tripadvisor: "#00AF87",
      facebook: "#3b5998",
      yelp: "#D32323",
      justeat: "#FF8000",
      smood: "#FF6B35",
      instagram: "#e4405f",
      twitter: "#1da1f2",
      youtube: "#ff0000"
    };
    return colors[type] || "#333";
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Здесь можно добавить логику отправки формы
    console.log('Form submitted:', formData);
    
    // Показать уведомление об успешной отправке
    alert('Сообщение отправлено!');
    
    // Очистить форму
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  return (
    <div className="contact-info">
      <div className="contact-info__container">
        <div className="contact-info__grid">
          
          {/* Левая колонка - Контактные данные */}
          <div className="contact-info__left">
            <h2 className="contact-info__title">
              {settings.contactTitle || 'KONTAKT'}
            </h2>
            
            <div className="contact-info__blocks">
              
              {/* Адрес */}
              {(settings.showAddress !== false) && (
                <div className="contact-info__block">
                  <div className="contact-info__icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="#4A90E2"/>
                    </svg>
                  </div>
                  <div className="contact-info__content">
                    <h3 className="contact-info__label">{getTranslation(language, 'contact.labels.address')}</h3>
                    <a 
                      href="https://maps.app.goo.gl/hVayZGyeMHNGGRke9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="contact-info__value contact-info__link"
                    >
                      {finalAddress}
                    </a>
                  </div>
                </div>
              )}

              {/* Телефон */}
              {(settings.showPhone !== false) && (
                <div className="contact-info__block">
                  <div className="contact-info__icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="#4A90E2"/>
                    </svg>
                  </div>
                  <div className="contact-info__content">
                    <h3 className="contact-info__label">{getTranslation(language, 'contact.labels.phone')}</h3>
                    <a 
                      href={`tel:${finalPhone.replace(/[\s\/]/g, '')}`}
                      className="contact-info__value contact-info__link"
                    >
                      {finalPhone}
                    </a>
                  </div>
                </div>
              )}

              {/* Часы работы */}
              {(settings.showHours !== false) && (
                <div className="contact-info__block">
                  <div className="contact-info__icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#4A90E2"/>
                    </svg>
                  </div>
                  <div className="contact-info__content">
                    <h3 className="contact-info__label">{getTranslation(language, 'contact.labels.hours')}</h3>
                    <p className="contact-info__value">
                      {finalHours}
                    </p>
                  </div>
                </div>
              )}

              {/* Email */}
              {(settings.showEmail !== false) && (
                <div className="contact-info__block">
                  <div className="contact-info__icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="#4A90E2"/>
                    </svg>
                  </div>
                  <div className="contact-info__content">
                    <h3 className="contact-info__label">{getTranslation(language, 'contact.labels.email')}</h3>
                    <a 
                      href={`mailto:${finalEmail}`}
                      className="contact-info__value contact-info__link"
                    >
                      {finalEmail}
                    </a>
                  </div>
                </div>
              )}

            </div>
          </div>

          {/* Средняя колонка - Форма обратной связи */}
          <div className="contact-info__center">
            <h2 className="contact-info__title">
              {finalFormTitle}
            </h2>
            
            <form className="contact-info__form" onSubmit={handleSubmit}>
              <div className="contact-info__form-group">
                <input
                  type="text"
                  name="name"
                  className="contact-info__input"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="contact-info__form-group">
                <input
                  type="email"
                  name="email"
                  className="contact-info__input"
                  placeholder="E-Mail"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="contact-info__form-group">
                <textarea
                  name="message"
                  className="contact-info__textarea"
                  placeholder="Nachricht"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="6"
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="contact-info__submit">
                {settings.submitText || 'SENDEN'}
              </button>
            </form>
          </div>

          {/* Правая колонка - Социальные сети */}
          <div className="contact-info__right">
            <h2 className="contact-info__title">
              {settings.socialTitle || 'FOLGEN SIE UNS'}
            </h2>
            
            <div className="contact-info__social">
              {socialMediaItems.map((social, index) => (
                <a 
                  key={index}
                  href={social.url} 
                  className={`contact-info__social-link ${social.type}`}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <span className="contact-info__social-icon">
                    <div className="contact-info__icon-wrapper" data-icon-type={social.type}>
                      <span style={{width: '24px', height: '24px', display: 'inline-block'}}>🔗</span>
                    </div>
                  </span>
                  <span className="contact-info__social-text">
                    {social.title}
                  </span>
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactInfo;